"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportChatsMapper = exportChatsMapper;
exports.dataMapper = dataMapper;
exports.groupMapper = groupMapper;
exports.patientCareTimeMapper = patientCareTimeMapper;
exports.downloadChatsMapper = downloadChatsMapper;
const models_1 = require("../models");
function exportChatsMapper(exportChatResponse) {
    return {
        data: exportChatResponse.data.map((data) => dataMapper(data)),
        limit: exportChatResponse.limit,
        page: exportChatResponse.page,
        total: exportChatResponse.total,
    };
}
function dataMapper(data) {
    return {
        downloadLink: data.downloadLink,
        exportType: models_1.EXPORT_TYPE[data.exportType],
        exportedAt: data.exportedAt,
        group: groupMapper(data.group),
        status: models_1.EXPORT_STATUS[data.status],
        id: data._id,
    };
}
function groupMapper(group) {
    return {
        name: group.name,
        patientCareTime: group.patientCareTime && patientCareTimeMapper(group.patientCareTime),
        patientStatus: group.patientStatus,
        status: group.status,
        id: group._id,
    };
}
function patientCareTimeMapper(patientCareTime) {
    return {
        startDate: patientCareTime.startDate,
        endDate: patientCareTime.endDate,
    };
}
function downloadChatsMapper(downloadChatResponse) {
    return {
        statusCode: downloadChatResponse.statusCode,
        message: downloadChatResponse.message,
        type: downloadChatResponse.type,
        data: downloadChatResponse.data,
    };
}
